





























import Vue from 'vue'

export default Vue.extend({
  data() {
    return {
      structureId: '',
      orderReference: '',
      amountValue: 0,
      iframeUrl: '',
      errorMessage: '',
    }
  },
  computed: {
    logoUrl(): string {
      return this.structureId ? `${process.env.VUE_APP_API_URL}/structure/${this.structureId}/logo` : ''
    },
    amountLabel(): string {
      return `${this.amountValue.toFixed(2)} €`
    },
  },
  mounted() {
    const { s, amount, order, token } = this.$route.query

    this.structureId = (s as string) || ''
    this.orderReference = (order as string) || ''

    const parsedAmount = Number(amount)
    this.amountValue = Number.isFinite(parsedAmount) ? parsedAmount : 0

    if (!token) {
      this.errorMessage = 'Parametre token manquant.'
      return
    }

    const parsedUrl = this.normalizePaymentUrl(token as string)
    if (!parsedUrl) {
      this.errorMessage = 'URL de paiement invalide ou non autorisee.'
      return
    }

    this.iframeUrl = parsedUrl
  },
  methods: {
    normalizePaymentUrl(token: string): string {
      const sanitizedToken = token.trim()

      if (!sanitizedToken) {
        return ''
      }

      return `${process.env.VUE_APP_API_URL}/pay/${encodeURIComponent(sanitizedToken)}`
    },
  },
})
